import { render } from "./ItemCardSpotlightView.vue?vue&type=template&id=4281560e&scoped=true&ts=true"
import script from "./ItemCardSpotlightView.vue?vue&type=script&lang=ts"
export * from "./ItemCardSpotlightView.vue?vue&type=script&lang=ts"

import "./ItemCardSpotlightView.vue?vue&type=style&index=0&id=4281560e&lang=scss&scoped=true"
import "./ItemCardSpotlightView.vue?vue&type=style&index=1&id=4281560e&lang=scss"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4281560e"]])

export default __exports__